import { BaseUniDriver } from '@wix/wix-ui-test-utils/unidriver';

export interface TagListUniDriver extends BaseUniDriver {
  actionButtonLabel: () => Promise<string>;
  clickActionButton: () => Promise<void>;
  actionButtonExists: () => Promise<boolean>;
  toggleMoreButtonLabel: () => Promise<string>;
  clickToggleMoreButton: () => Promise<void>;
  toggleMoreButtonExists: () => Promise<boolean>;
  removeTag: (id: string) => Promise<void>;
}
